import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconMapPin = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({ viewBox: "-4 -2 24 24" }, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { d: "m8 20-.7-.78C6.5 18.439 0 11.511 0 7.61 0 5.56.8 3.707 2.4 2.244 3.9.78 5.9 0 8 0c4.4 0 8 3.415 8 7.61 0 3.902-6.5 10.829-7.3 11.61L8 20ZM8 1.951c-1.6 0-3.1.586-4.3 1.659C2.6 4.683 2 6.049 2 7.61c0 2.146 3.4 6.634 6 9.56 2.6-2.829 6-7.414 6-9.56 0-3.122-2.7-5.659-6-5.659Z" }),
            React.createElement("path", { d: "M8 8.78c1.105 0 2-.873 2-1.95 0-1.078-.895-1.952-2-1.952S6 5.752 6 6.83c0 1.078.895 1.951 2 1.951Z" }))));
};
